export const processSite = () => {
  // let tmp = "www.jommall.com";
  // tmp = tmp.replace(/^www\./, '');
  // return tmp; //THIS IS PRODUCTION SITE DOMAIN
  return "jombiz-ecomm-uat.techbasemlm.com"; //THIS IS UAT SITE DOMAIN
};

export const EcommURL = (param) => {
  let tmp = "";
  if (param.indexOf("localhost") !== -1 || param.indexOf("127.0.0.1") !== -1) {
    tmp = "http://localhost:4051";
  } else {
    tmp = `https://${processSite()}`;
  }
  return tmp;
};
